<template>
    <div :class="`
        responsive-results-header
        ${!$store.state.isApp || ($store.state.isApp && $device.android()) ? 'active' : ''}`
        "
        v-if="($device.mobile() || $store.state.isApp) && !showMenu"
    >
        <div class="responsive-results-noti">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" width="29px" height="29px">
                <g fill="none" fill-rule="evenodd">
                    <circle cx="14.5" cy="14.5" r="14.5" fill="#6F9F13"/>
                    <path fill="#FFF" fill-rule="nonzero"
                          d="M20.2375 12.5751328c0-3.96376135-2.1875-5.31209-4.2333333-5.61262108 0-.02030616.0041666-.04061231.0041666-.0649797C16.0083333 6.39800062 15.5541667 6 15 6c-.5541667 0-.9916667.39800062-.9916667.89753202 0 .02436739 0 .04467354.0041667.0649797-2.05.30459231-4.25 1.65698219-4.25 5.62074348C9.7625 17.204936 8.58333333 17.7004061 7 19h16c-1.575-1.3036551-2.7625-1.8031865-2.7625-6.4248672zM15 21c2.073501 0 3.7756286-.4627907 4-1h-8c.2166344.5372093 1.926499 1 4 1z"/>
                </g>
            </svg>
            <span>Vakta leitarniðurstöður</span>
        </div>
        <span style="position: relative;">
        <save-search
                     :sub="sub"
                     :s="'34'"
                     :subscriber="subscriber"
                     :filters="filters"
        />
      </span>
    </div>
</template>


<script>
import SaveSearch from "@/components/SaveSearch";
import {mapGetters} from "vuex";
export default {
    props:[
        "sub",
        "subscriber",
        "filters"
    ],
    components: {
        SaveSearch
    },
    computed: {
        ...mapGetters([
          "showMenu"
        ]),
    },
}
</script>